module.exports = __webpack_public_path__ + "img/complacency.1f0fc06e.svg";